"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Logo = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Logo, _Component);

  var _super = _createSuper(Logo);

  function Logo() {
    var _this;

    (0, _classCallCheck2.default)(this, Logo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      src: _this.props.src
    });
    return _this;
  }

  (0, _createClass2.default)(Logo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          communityCustomerTitle = _this$props.communityCustomerTitle,
          className = _this$props.className;
      var src = this.state.src; // We don't want to render the logo if the src is empty, it leads to an empty link that harms accessibility

      if (!src) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('header-navigation_logo-wrapper', className)
      }, (0, _preact.h)(_trackingLink.default, {
        target: "_self",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/"),
        "aria-label": (0, _translations.t)('Forum', 'go.to.homepage'),
        className: "header-navigation_logo-anchor",
        track: {
          type: 'Mega Menu click on logo',
          event_source: 'control'
        }
      }, (0, _preact.h)("img", {
        className: "header-navigation_logo",
        src: (0, _absoluteUrlRuntime.resolveUrl)(src),
        alt: "".concat(communityCustomerTitle, " Logo")
      })));
    }
  }]);
  return Logo;
}(_preact.Component);

exports.Logo = Logo;